import styles from "./nfse.module.css"
import r2slogo from '../../../../img/r2s-logo.png'
import oblogo from '../../../../img/ob-logo.png'
import { Button, Col, Form, Row } from "react-bootstrap"
import { FormEvent, useEffect, useState } from "react"
import removeAllErrorMsg from "../../../../components/funcRemoveAllErros"
import Select from "react-select"
import { NFSeCadastrarDto } from "./dto/ViewNotaDto"
import DetalhesEmpresa from "./componentes/DetalhesEmpresa"
import DetalhesCliente from "./componentes/DetalhesCliente"
import $ from 'jquery'
import 'jquery-mask-plugin'
import { defineTextInElementId, defineValueInInput, getElementFromId, getTextInElementId, getValueFromInput } from "../../../../components/funcForInput"
import { toast } from "react-toastify"
import { ApiEndpoints, LinkEndpoint, reqGetDownloadFile, reqPatch, reqPostNew, reqPut } from "../../../../config/apiClient"
import LoadingModal from "../../../../components/loadingModal"
import IdentificacaoNFSe from "./componentes/IdentificacaoNFSe"
import dayjs from "dayjs"
import NFSeModalEmissaoErro from "./componentes/ModalEmissaoErro"
import { getUrlSearchParams } from "../../../urlParams"
import EventosNFSe from "./componentes/EventosNFSe"
import ModalCancelarNfse from "./componentes/ModalCancelarNfse"
import ClienteUltimasNotasEmitidas from "./componentes/ClienteUltimasNotasEmitidas"
import NFSeModalVisualizarISSConsulta from "./componentes/ModalVisualizarISSConsulta"
import { NFSE_NBS_CLASS_TRIB_OPTIONS, NFSE_NBS_CST_OPTIONS, NFSE_NBS_OPERACAO_COD_OPTIONS, NFSE_NBS_OPTIONS } from "./ServicoNBSOptions"

export default function ViewNotaPage({ empresa, nota, handleSairNota, filtros, modelo }: iViewNotaPageProps) {
    const clientesFiltro: any[] = filtros.clientes.filter((reg: any) => reg.id_empresa === empresa.id_empresa)
    useEffect(() => {
        $('.dinheiro').mask('###.###.###.###.###.###.##0,00', { reverse: true, placeholder: "0,00" });
        $('.porcentagem').mask('000.00', { reverse: true, placeholder: "0.00" });
        definirCamposSelect()
        if (Object.values(nota).length > 0) {
            carregarNota(nota)
        } else if (Object.values(modelo).length > 0) {
            carregarModelo(modelo)
        } else {
            defineValueInInput("data_competencia", dayjs().format("YYYY-MM-DD"))
            if (empresa.nfs_situacao_simp_nac === 3) {
                defineValueInInput("ISS", formatarPorcentagem(empresa.nfs_ISS))
                setTributoISSAux(empresa.nfs_ISS)
            }
            if (empresa.cnpj === "20979890000132") { 
                setShowServicoNBS(true)
            }
        }
        // eslint-disable-next-line
    }, [])
    // Dados formulário
    const [idCliente, setIdCliente] = useState<any>({ "value": "0", "label": "Não Selecionado" })
    const [idServico, setIdServico] = useState<any>({ "value": "0", "label": "Não Selecionado" })
    const [idServicoMun, setIdServicoMun] = useState<any>({ "value": "0", "label": "Não Selecionado" })
    const [idServicoNBS, setIdServicoNBS] = useState<any>({ "value": "0", "label": "Não Selecionado" })
    const [idIBSCBSOperacaoCod, setIdIBSCBSOperacaoCod] = useState<any>({ "value": "0", "label": "Não Selecionado" })
    const [idIBSCBSCstCod, setIdIBSCBSCstCod] = useState<any>({ "value": "0", "label": "Não Selecionado" })
    const [idIBSCBSClassTribCod, setIdIBSCBSClassTribCod] = useState<any>({ "value": "0", "label": "Não Selecionado" })
    const [codCidade, setCodCidade] = useState<any>({ "value": "0", "label": "Não Selecionado" })
    // Atualizado 25/08/2025: Não vai ser possível informar essa campo na DPS.
    // const [codCidadeIss, setCodCidadeIss] = useState<any>({ "value": "0", "label": "Não Selecionado" })
    // Dados Página
    const [idClienteFiltro, setIdClienteFiltro] = useState<any[]>([])
    const [idServicoFiltro, setIdServicoFiltro] = useState<any[]>([])
    const [idServicoFiltroMun, setIdServicoFiltroMun] = useState<any[]>([])
    const [showServicoMun, setShowServicoMun] = useState<boolean>(false)
    const [servicoObs, setServicoObs] = useState<string>("")
    const [showServicoNBS, setShowServicoNBS] = useState<boolean>(false)
    const [tributoISSAux, setTributoISSAux] = useState<string>("")
    const [bloquearISS, setBloquearISS] = useState<boolean>(false)
    const [codCidadeFiltro, setCodCidadeFiltro] = useState<any[]>([])
    const [isFormDisabled, setIsFormDisabled] = useState<boolean>(false)
    const [isValoresDisabled, setIsValoresDisabled] = useState<boolean>(true)
    const [showModalErroEmissao, setShowModalErroEmissao] = useState<boolean>(false)
    const [modalErroEmissaoResponse, setModalErroEmissaoResponse] = useState<any>({})
    const [showModalConsutarISS, setShowModalConsultarISS] = useState<boolean>(false)
    const [modalConsultarISSResponse, setModalConsultarISSResponse] = useState<any>({})
    const [showModalCancelar, setShowModalCancelar] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [notaDados, setNotaDados] = useState<any>(nota)
    const [notaPodeCancelar, setNotaPodeCancelar] = useState<boolean>(true)
    const [notaFoiEditada, setNotaFoiEditada] = useState<boolean>(false)
    const [carregarNotas, setCarregarNotas] = useState<boolean>(false)

    function definirCamposSelect() {
        let clientesFiltroAtivos = clientesFiltro.filter((reg) => reg.situacao === 1)
        let clientesAux = clientesFiltroAtivos.map((item: any, index: any) => (
            {
                "value": `${item.id_cliente}`,
                "label": `#${item.id_cliente} ${item.nome} - ${item.tipo === 'PJ' ? `CNPJ ${item.cnpj}` : `CPF ${item.cpf}`}`
            }
        ))
        setIdClienteFiltro(clientesAux)
        let servicosEmpresasFiltro: any[] = filtros.servicos_empresas.filter((reg: any) => reg.id_empresa === empresa.id_empresa)
        let servicosFiltro: any[] = []
        for (let servico of servicosEmpresasFiltro) {
            const item = Number(String(servico.cod_serv).split(".")[0])
            const subitem = Number(String(servico.cod_serv).split(".")[1])
            const servicos = filtros.servicos.filter((reg: any) => reg.servico_item === item && reg.servico_subitem === subitem)
            if (servicos.length > 0) {
                servicosFiltro.push(servicos[0])
            }
            continue
        }
        let servicosAux = servicosFiltro.map((item: any, index: any) => (
            {
                "value": `${item.servico_cod}`,
                "label": `#${item.servico_cod} ${item.servico_descricao} - ${item.tributos_situacao === 1 ? "Retido" : "Tributado"}`
            }
        ))
        setIdServicoFiltro(servicosAux)
        // let cidadesAux = filtros.cidades.map((item: any, index: any) => (
        //     {
        //         "value": `${item.cod_cidade}`,
        //         "label": `(${item.cod_cidade}) ${item.nome}/${item.uf} - Cep ${item.cep}`
        //     }
        // ))
        let cidadesAux = filtros.cidades.map((item: any, index: any) => (
            {
                "value": `${item.cod_cidade}`,
                "label": `${item.nome}/${item.uf}`
            }
        ))
        setCodCidadeFiltro(cidadesAux)
    }
    function carregarModelo(modeloAux: any) {
        let form: any = document.getElementById("formNFSe")
        setIdCliente({
            "value": modeloAux.id_cliente.id_cliente,
            "label": `#${modeloAux.id_cliente.id_cliente} ${modeloAux.id_cliente.nome} - ${modeloAux.id_cliente.tipo === 'PJ' ? `CNPJ ${modeloAux.id_cliente.cnpj}` : `CPF ${modeloAux.id_cliente.cpf}`}`
        })
        const servico = filtros.servicos.filter((reg: any) => reg.servico_cod === modeloAux.servico_cod)[0]
        setIdServico({
            "value": `${servico.servico_cod}`,
            "label": `#${servico.servico_cod} ${servico.servico_descricao} - ${servico.tributos_situacao === 1 ? "Retido" : "Tributado"}`
        })
        const situacao_tributos = modeloAux.trib_iss_ret === 2 ? "Retido" : "Tributado"
        const situacao_tributos_cod = modeloAux.trib_iss_ret
        defineValueInInput("situacao_tributos", situacao_tributos_cod)
        handleChangeSituacaoTributos(situacao_tributos)

        const cidadeServico = filtros.cidades.filter((reg: any) => reg.cod_cidade === modeloAux.servico_cidade_cod)[0]
        setCodCidade({
            "value": `${cidadeServico.cod_cidade}`,
            "label": `${cidadeServico.nome}/${cidadeServico.uf}`
        })
        if (modeloAux.servico_mun_id !== null) {
            setShowServicoMun(true)
            const cidade_cod = modeloAux.servico_cidade_cod
            const servico_mun_id = modeloAux.servico_mun_id
            const servicos_mun: any[] = filtros.servicos_mun.filter((reg: any) => reg.id === servico_mun_id)
            if (servicos_mun.length > 0) { 
                handleServiceMun(cidade_cod)
                const servico_mun = servicos_mun[0]
                setIdServicoMun({
                    "value": `${servico_mun_id}`,
                    "label": `#${servico_mun.servico_cod}-${servico_mun.servico_cod_mun} ${servico_mun.servico_descricao}`
                })
            }
        }

        if (modeloAux.servico_nbs_cod !== null) {
            const options_nbs = NFSE_NBS_OPTIONS.filter(reg => reg.value === modeloAux.servico_nbs_cod)
            if (options_nbs.length > 0) {
                setShowServicoNBS(true)
                const nbs_cod = options_nbs[0]
                setIdServicoNBS({
                    "value": `${nbs_cod.value}`,
                    "label": `${nbs_cod.label}`
                })
            }
            
            const options_operacao_cod = NFSE_NBS_OPERACAO_COD_OPTIONS.filter(reg => reg.value === modeloAux.IBSCBS_operacao_cod)
            if (options_operacao_cod.length > 0) {
                const operacao_cod = options_operacao_cod[0]
                setIdIBSCBSOperacaoCod({
                    "value": `${operacao_cod.value}`,
                    "label": `${operacao_cod.label}`
                })
            }
            
            const options_cst = NFSE_NBS_CST_OPTIONS.filter(reg => reg.value === modeloAux.IBSCBS_cst_cod)
            if (options_cst.length > 0) {
                const cst_cod = options_cst[0]
                setIdIBSCBSCstCod({
                    "value": `${cst_cod.value}`,
                    "label": `${cst_cod.label}`
                })
            }
            
            const options_class_trib = NFSE_NBS_CLASS_TRIB_OPTIONS.filter(reg => reg.value === modeloAux.IBSCBS_class_trib_cod)
            if (options_class_trib.length > 0) {
                const class_trib_cod = options_class_trib[0]
                setIdIBSCBSClassTribCod({
                    "value": `${class_trib_cod.value}`,
                    "label": `${class_trib_cod.label}`
                })
            }
        } else { 
            setShowServicoNBS(false)
        }

        form.situacao_pis_cofins.value = String(modeloAux.trib_fed_ret_PISCOFINS)
        form.valor.value = formatarDinheiro(modeloAux.valor_servicos)
        form.data_competencia.value = dayjs().format("YYYY-MM-DD")

        let descriminacao: string = modeloAux.servico_descriminacao
        let info_complementar: string = modeloAux.servico_info_complementar === null ? "" : modeloAux.servico_info_complementar
        if (modeloAux.tipo_referencia === 1) {
            let ref: string = dayjs().startOf('month').subtract(1, 'day').locale('pt-br').format("MMMM/YYYY").toUpperCase()
            descriminacao = descriminacao.replaceAll("#ref#", ref)
            info_complementar = info_complementar.replaceAll("#ref#", ref)

           let data_inicial = dayjs().startOf('month').subtract(1, 'day').startOf('month').format("DD/MM/YYYY")
            let data_final = dayjs().startOf('month').subtract(1, 'day').endOf('month').format("DD/MM/YYYY")
            let periodo = `${data_inicial} À ${data_final}`
            descriminacao = descriminacao.replaceAll("#periodo#", periodo)
            info_complementar = info_complementar.replaceAll("#periodo#", periodo)
        }
        if (modeloAux.tipo_referencia === 2) {
            let ref: string = dayjs().locale('pt-br').format("MMMM/YYYY").toUpperCase()
            descriminacao = descriminacao.replaceAll("#ref#", ref)
            info_complementar = info_complementar.replaceAll("#ref#", ref)

            let data_inicial = dayjs().startOf('month').format("DD/MM/YYYY")
            let data_final = dayjs().endOf('month').format("DD/MM/YYYY")
            let periodo = `${data_inicial} À ${data_final}`
            descriminacao = descriminacao.replaceAll("#periodo#", periodo)
            info_complementar = info_complementar.replaceAll("#periodo#", periodo)
        }

        form.descriminacao.value = descriminacao
        form.info_complementar.value = info_complementar

        form.IRRF.value = formatarPorcentagem(modeloAux.IRRF)
        form.IRRF_V.value = formatarDinheiro(modeloAux.IRRF_V)

        form.INSS.value = formatarPorcentagem(modeloAux.CP)
        form.INSS_V.value = formatarDinheiro(modeloAux.CP_V)

        form.COFINS.value = formatarPorcentagem(modeloAux.COFINS)
        form.COFINS_V.value = formatarDinheiro(modeloAux.COFINS_V)

        form.CSLL.value = formatarPorcentagem(modeloAux.CSLL)
        form.CSLL_V.value = formatarDinheiro(modeloAux.CSLL_V)

        form.PIS.value = formatarPorcentagem(modeloAux.PIS)
        form.PIS_V.value = formatarDinheiro(modeloAux.PIS_V)

        if (empresa.nfs_situacao_simp_nac === 3 && situacao_tributos === "Retido") {
            defineValueInInput("ISS", formatarPorcentagem(empresa.nfs_ISS))
            setTributoISSAux(empresa.nfs_ISS)
        } else {
            defineValueInInput("ISS", formatarPorcentagem(modeloAux.ISS))
            setTributoISSAux(modeloAux.ISS)
        }
        // handleChangeSituacaoTributos(situacao_tributos)

        form.BASE_V.value = formatarDinheiro(modeloAux.valor_servicos)
        form.TRIBUTOS_V.value = formatarDinheiro(modeloAux.valor_tributos)
        form.LIQUIDO_V.value = formatarDinheiro(modeloAux.valor_liquido)

        handleCalcTributos()
    }
    function carregarNota(notaAux: any) {
        console.log(notaAux)
        let form: any = document.getElementById("formNFSe")
        if (notaAux.status === "Emitido" || notaAux.status === "Emitido (Cancelado)") {
            setIsFormDisabled(true)
            setIsValoresDisabled(true)
        }
        setIdCliente({
            "value": notaAux.id_cliente.id_cliente,
            "label": `#${notaAux.id_cliente.id_cliente} ${notaAux.id_cliente.nome} - ${notaAux.id_cliente.tipo === 'PJ' ? `CNPJ ${notaAux.id_cliente.cnpj}` : `CPF ${notaAux.id_cliente.cpf}`}`
        })
        const servico = filtros.servicos.filter((reg: any) => reg.servico_cod === notaAux.servico_cod)[0]
        setIdServico({
            "value": `${servico.servico_cod}`,
            "label": `#${servico.servico_cod} ${servico.servico_descricao} - ${servico.tributos_situacao === 1 ? "Retido" : "Tributado"}`
        })

        const servico_mun = notaAux.servico_mun_id
        if (servico_mun !== null) {
            setShowServicoMun(true)
            handleServiceMun(notaAux.servico_cidade_cod)
            setIdServicoMun({
                "value": `${servico_mun.id}`,
                "label": `#${servico_mun.servico_cod}-${servico_mun.servico_cod_mun} ${servico_mun.servico_descricao}`
            })
        }

        if (notaAux.servico_nbs_cod !== null) { 
            const options_nbs = NFSE_NBS_OPTIONS.filter(reg => reg.value === notaAux.servico_nbs_cod)
            if (options_nbs.length > 0) { 
                setShowServicoNBS(true)
                const nbs_cod = options_nbs[0]
                setIdServicoNBS({
                    "value": `${nbs_cod.value}`,
                    "label": `${nbs_cod.label}`
                })
            }
            
            const options_operacao_cod = NFSE_NBS_OPERACAO_COD_OPTIONS.filter(reg => reg.value === notaAux.IBSCBS_operacao_cod)
            if (options_operacao_cod.length > 0) { 
                const operacao_cod = options_operacao_cod[0]
                setIdIBSCBSOperacaoCod({
                    "value": `${operacao_cod.value}`,
                    "label": `${operacao_cod.label}`
                })
            }
            
            const options_cst = NFSE_NBS_CST_OPTIONS.filter(reg => reg.value === notaAux.IBSCBS_cst_cod)
            if (options_cst.length > 0) { 
                const cst_cod = options_cst[0]
                setIdIBSCBSCstCod({
                    "value": `${cst_cod.value}`,
                    "label": `${cst_cod.label}`
                })
            }
            
            const options_class_trib = NFSE_NBS_CLASS_TRIB_OPTIONS.filter(reg => reg.value === notaAux.IBSCBS_class_trib_cod)
            if (options_class_trib.length > 0) { 
                const class_trib_cod = options_class_trib[0]
                setIdIBSCBSClassTribCod({
                    "value": `${class_trib_cod.value}`,
                    "label": `${class_trib_cod.label}`
                })
            }
        }
        
        const situacao_tributos = notaAux.trib_iss_ret === 2 ? "Retido" : "Tributado"
        const situacao_tributos_cod = notaAux.trib_iss_ret
        defineValueInInput("situacao_tributos", situacao_tributos_cod)
        handleChangeSituacaoTributos(situacao_tributos)
        
        // Atualizado 25/08/2025: Não vai ser possível informar essa campo na DPS.
        // const cidade = filtros.cidades.filter((reg: any) => reg.cod_cidade === notaAux.cidade_cod)[0]
        // setCodCidadeIss({
        //     "value": `${cidade.cod_cidade}`,
        //     "label": `${cidade.nome}/${cidade.uf}`
        // })
        const cidadeServico = filtros.cidades.filter((reg: any) => reg.cod_cidade === notaAux.servico_cidade_cod)[0]
        setCodCidade({
            "value": `${cidadeServico.cod_cidade}`,
            "label": `${cidadeServico.nome}/${cidadeServico.uf}`
        })
        if (notaAux.status !== "Emitido" && notaAux.status !== "Emitido (Cancelado)") {
            if (servico_mun === null) {
                handleServiceMun(cidadeServico.cod_cidade)
            }
        }

        // Identificação NFSe
        form.id_chave.value = notaAux.id_chave
        form.nNFSe.value = notaAux.nNFSe
        form.dps_numero.value = notaAux.dps_numero
        form.dps_serie.value = notaAux.dps_serie
        form.data_criacao.value = notaAux.data_criacao === null ? "" : dayjs(notaAux.data_criacao).format("DD/MM/YYYY HH:mm:ss")
        form.data_emissao.value = notaAux.data_emissao === null ? "" : dayjs(notaAux.data_emissao).format("DD/MM/YYYY HH:mm:ss")

        const data_atual = dayjs()
        const data_emitido = dayjs(notaDados.data_emissao)
        const diff = data_atual.diff(data_emitido, "days")
        if (diff > 30) {
            setNotaPodeCancelar(false)
            // window.alert("Nota não pode mais ser cancelada!")
            // return
        }

        form.status.value = notaAux.status
        form.situacao_pis_cofins.value = String(notaAux.trib_fed_ret_PISCOFINS)
        form.valor.value = formatarDinheiro(notaAux.valor_servicos)
        form.data_competencia.value = notaAux.dps_data_competencia
        form.descriminacao.value = notaAux.servico_descriminacao
        form.info_complementar.value = notaAux.servico_info_complementar

        form.IRRF.value = formatarPorcentagem(notaAux.IRRF)
        form.IRRF_V.value = formatarDinheiro(notaAux.IRRF_V)

        form.INSS.value = formatarPorcentagem(notaAux.CP)
        form.INSS_V.value = formatarDinheiro(notaAux.CP_V)

        form.COFINS.value = formatarPorcentagem(notaAux.COFINS)
        form.COFINS_V.value = formatarDinheiro(notaAux.COFINS_V)

        form.CSLL.value = formatarPorcentagem(notaAux.CSLL)
        form.CSLL_V.value = formatarDinheiro(notaAux.CSLL_V)
        form.CSLL_V2.value = formatarDinheiro(notaAux.CSLL_V2)

        form.PIS.value = formatarPorcentagem(notaAux.PIS)
        form.PIS_V.value = formatarDinheiro(notaAux.PIS_V)

        form.ISS.value = formatarPorcentagem(notaAux.ISS)
        form.ISS_V.value = formatarDinheiro(notaAux.ISS_V)
        setTributoISSAux(notaAux.ISS)

        handleChangeTributosRetidos()
        handleCalcLegendaTributos()

        form.BASE_V.value = formatarDinheiro(notaAux.valor_servicos)
        form.TRIBUTOS_V.value = formatarDinheiro(notaAux.valor_tributos)
        form.LIQUIDO_V.value = formatarDinheiro(notaAux.valor_liquido)
    }

    function handleVerififyChanges() {
        const form = getElementFromId("formNFSe")

        const dados = {
            id_cliente: Number(idCliente.value),
            dps_data_competencia: form.data_competencia.value,
            servico_cod: idServico.value,
            servico_cod_mun: Number(idServicoMun.value) === 0 ? null : Number(idServicoMun.value),

            valor_servicos: getInputDinheiro("valor"),
            servico_cidade_cod: Number(codCidade.value),
            ISS: getInputPorcentagem("ISS"),
            ISS_V: getInputDinheiro("ISS_V"),
            trib_iss_ret: Number(form.situacao_tributos.value),
            trib_fed_ret_PISCOFINS: Number(form.situacao_pis_cofins.value),

            COFINS: getInputPorcentagem("COFINS"),
            COFINS_V: getInputDinheiro("COFINS_V"),
            PIS: getInputPorcentagem("PIS"),
            PIS_V: getInputDinheiro("PIS_V"),
            CP: getInputPorcentagem("INSS"),
            CP_V: getInputDinheiro("INSS_V"),
            IRRF: getInputPorcentagem("IRRF"),
            IRRF_V: getInputDinheiro("IRRF_V"),
            CSLL: getInputPorcentagem("CSLL"),
            CSLL_V: getInputDinheiro("CSLL_V"),
            valor_liquido: getInputDinheiro("LIQUIDO_V"),
            valor_tributos: getInputDinheiro("TRIBUTOS_V"),

            servico_descriminacao: form.descriminacao.value,
            servico_info_complementar: form.info_complementar.value === "" ? null : form.info_complementar.value,
        }

        const dadosAuxNota = {
            id_cliente: notaDados.id_cliente.id_cliente,
            dps_data_competencia: notaDados.dps_data_competencia,
            servico_cod: notaDados.servico_cod,
            servico_cod_mun: notaDados.servico_mun_id === null ? null : Number(notaDados.servico_mun_id.id),

            valor_servicos: String(notaDados.valor_servicos).search(",") < 0 ? notaDados.valor_servicos : String(notaDados.valor_servicos).replaceAll("R$ ", "").replaceAll(".", "").replaceAll(",", "."),
            servico_cidade_cod: notaDados.servico_cidade_cod,
            ISS: notaDados.ISS,
            ISS_V: notaDados.ISS_V,
            trib_iss_ret: notaDados.trib_iss_ret,
            trib_fed_ret_PISCOFINS: notaDados.trib_fed_ret_PISCOFINS,

            COFINS: notaDados.COFINS,
            COFINS_V: notaDados.COFINS_V,
            PIS: notaDados.PIS,
            PIS_V: notaDados.PIS_V,
            CP: notaDados.CP,
            CP_V: notaDados.CP_V,
            IRRF: notaDados.IRRF,
            IRRF_V: notaDados.IRRF_V,
            CSLL: notaDados.CSLL,
            CSLL_V: notaDados.CSLL_V,
            // valor_liquido: notaDados.valor_liquido,
            valor_liquido: String(notaDados.valor_liquido).search(",") < 0 ? notaDados.valor_liquido : String(notaDados.valor_liquido).replaceAll("R$ ", "").replaceAll(".", "").replaceAll(",", "."),
            valor_tributos: notaDados.valor_tributos,

            servico_descriminacao: notaDados.servico_descriminacao,
            servico_info_complementar: notaDados.servico_info_complementar === "" ? null : notaDados.servico_info_complementar,
        }

        return handleCompararObjetos(dados, dadosAuxNota)
    }
    function handleCompararObjetos(a: any, b: any) {
        if (a === b) return true; // valores primitivos iguais
        if (typeof a !== "object" || typeof b !== "object" || a == null || b == null) {
            return false;
        }
        const keysA = Object.keys(a);
        const keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        for (let key of keysA) {
            if (!keysB.includes(key) || !handleCompararObjetos(a[key], b[key])) {
                return false;
            }
        }
        return true;
    }
    function handleChangeSituacaoTributos(situacao_tributos: string) {
        if (situacao_tributos === "Tributado") {
            if ((Object.values(notaDados).length === 0 || Object.values(notaDados).length !== 0) && empresa.nfs_situacao_simp_nac === 3) {
                setServicoObs("Obs.: Não informar ISS, quando a empresa utiliza o SIMPLES NACIONAL e serviço é TRIBUTADO.")
                setBloquearISS(true)
                defineValueInInput("ISS", "0.00")
                handleCalcTributo("ISS")
                handleCalcValorLiquido()
            }
        } else {
            setServicoObs("")
            setBloquearISS(false)
            defineValueInInput("ISS", formatarPorcentagem(tributoISSAux))
        }
    }

    function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault()
        event.stopPropagation()
        removeAllErrorMsg()

        const form: any = event.target
        let formValidado = true

        let urlParams: URLSearchParams = getUrlSearchParams()
        let id_nota: number | null = null
        if (Number(urlParams.get("id_nota")) > 0) {
            id_nota = Number(urlParams.get("id_nota"))
        }

        let dados: NFSeCadastrarDto = {
            id_nota: id_nota,
            // Atualizado 25/08/2025: Não vai ser possível informar essa campo na DPS.
            // cidade_cod: Number(codCidadeIss.value),
            // Editado: 03/09/2025 Esse campo será definido pelo Sistema Nacional do NFSe
            // cidade_cod: Number(codCidade.value),
            // cidade_descricao: "",
            servico_cod: idServico.value,
            servico_descricao: "",
            servico_cod_mun: null,
            servico_descricao_mun: null,
            servico_mun_id: idServicoMun.value === "0" ? null : Number(idServicoMun.value),
            servico_descriminacao: form.descriminacao.value,
            servico_info_complementar: form.info_complementar.value,
            servico_cidade_cod: Number(codCidade.value),
            servico_cidade_descricao: "",
            servico_nbs_cod: idServicoNBS.value,
            id_empresa: empresa.id_empresa,
            id_cliente: Number(idCliente.value),
            valor_servicos: getInputDinheiro("valor"),
            valor_liquido: getInputDinheiro("LIQUIDO_V"),
            valor_tributos: getInputDinheiro("TRIBUTOS_V"),
            dps_data_competencia: form.data_competencia.value,
            trib_iss: 1,
            trib_iss_ret: Number(form.situacao_tributos.value),
            ISS: getInputPorcentagem("ISS"),
            ISS_V: getInputDinheiro("ISS_V"),
            trib_fed_cst: 1, // 01 - Operação Tributável com Alíquota Básica;
            COFINS: getInputPorcentagem("COFINS"),
            COFINS_V: getInputDinheiro("COFINS_V"),
            PIS: getInputPorcentagem("PIS"),
            PIS_V: getInputDinheiro("PIS_V"),
            trib_fed_ret_PISCOFINS: Number(form.situacao_pis_cofins.value),
            CP: getInputPorcentagem("INSS"),
            CP_V: getInputDinheiro("INSS_V"),
            IRRF: getInputPorcentagem("IRRF"),
            IRRF_V: getInputDinheiro("IRRF_V"),
            CSLL: getInputPorcentagem("CSLL"),
            CSLL_V: getInputDinheiro("CSLL_V"),
            CSLL_V2: getInputDinheiro("CSLL_V2"),
            IBSCBS_operacao_cod: idIBSCBSOperacaoCod.value,
            IBSCBS_cst_cod: idIBSCBSCstCod.value,
            IBSCBS_class_trib_cod: idIBSCBSClassTribCod.value,
            ambiente_tipo: empresa.nfs_tipo_ambiente,
        }

        if (dados.id_cliente === 0) {
            form.id_cliente_aux.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.servico_cod === "0") {
            form.id_servico_aux.nextElementSibling.style.display = "block"
            formValidado = false
        } else {
            const servico = filtros.servicos.filter((reg: any) => reg.servico_cod === dados.servico_cod)
            if (servico.length > 0) {
                dados.servico_descricao = servico[0].servico_descricao
            }
            // if (situacao_tributos === 1) {
            //     dados.trib_iss_ret = 1
            // }
            // if (situacao_tributos === 2) {
            //     dados.trib_iss = 1
            //     dados.trib_iss_ret = 2
            // }
        }

        if (showServicoNBS) {
            if (dados.servico_nbs_cod === "0") {
                form.servico_nbs_cod_aux.nextElementSibling.style.display = "block"
                formValidado = false
            }
            if (dados.IBSCBS_operacao_cod === "0") {
                form.IBSCBS_operacao_cod_aux.nextElementSibling.style.display = "block"
                formValidado = false
            }
            if (dados.IBSCBS_cst_cod === "0") {
                form.IBSCBS_cst_cod_aux.nextElementSibling.style.display = "block"
                formValidado = false
            }
            if (dados.IBSCBS_class_trib_cod === "0") {
                form.IBSCBS_class_trib_cod_aux.nextElementSibling.style.display = "block"
                formValidado = false
            }
        } else { 
            dados.servico_nbs_cod = null
            dados.IBSCBS_operacao_cod = null
            dados.IBSCBS_cst_cod = null
            dados.IBSCBS_class_trib_cod = null
        }
        
        if (dados.servico_mun_id !== null) {
            const servicos_mun = filtros.servicos_mun.filter((reg:any) => reg.id === dados.servico_mun_id)
            if (servicos_mun.length > 0) {
                const servico_mun = servicos_mun[0]
                dados.servico_cod_mun = servico_mun.servico_cod_mun
                dados.servico_descricao_mun = servico_mun.servico_descricao
            }
        }
        if (dados.servico_cidade_cod > 0) {
            const servicos_mun:any[] = filtros.servicos_mun.filter((reg:any) => reg.cidade_cod === dados.servico_cidade_cod)
            if (servicos_mun.length > 0 && dados.servico_mun_id === null) {
                toast.warning('Informe o código do Serviço Municipal!', {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
                formValidado = false
            }
        }

        if (dados.trib_iss_ret === 0) { 
            form.situacao_tributos.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.trib_fed_ret_PISCOFINS === 99) {
            dados.trib_fed_cst = null
            if (dados.PIS !== "0.00" || dados.COFINS !== "0.00") {
                toast.error('CSLL/PIS/COFINS não pode haver valores!', {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
                formValidado = false
            }
        } else {
            if (dados.trib_fed_ret_PISCOFINS >= 0 && dados.trib_fed_ret_PISCOFINS !== 1 && dados.trib_fed_ret_PISCOFINS !== 2) {
                if (dados.PIS === "0.00" || dados.COFINS === "0.00" || dados.CSLL === "0.00") {
                    toast.error('Necessário informar CSLL/PIS/COFINS!', {
                        containerId: 1,
                        position: 'top-center',
                        theme: 'dark'
                    })
                    formValidado = false
                }
            }
            if (dados.trib_fed_ret_PISCOFINS === 1 || dados.trib_fed_ret_PISCOFINS === 2) {
                if (dados.CSLL !== "0.00") {
                    toast.error('CSLL não pode haver valores!', {
                        containerId: 1,
                        position: 'top-center',
                        theme: 'dark'
                    })
                    formValidado = false
                }
                if (dados.PIS === "0.00" || dados.COFINS === "0.00") {
                    toast.error('Necessário informar PIS/COFINS!', {
                        containerId: 1,
                        position: 'top-center',
                        theme: 'dark'
                    })
                    formValidado = false
                }
            }
        }
        if (dados.servico_descriminacao === "" || dados.servico_descriminacao.length < 15) {
            form.descriminacao.nextElementSibling.style.display = "block"
            formValidado = false
        }
        // Editado: 06/08/2025 - Esse campo não precisa ser obrigatório.
        // if (dados.servico_info_complementar === "" || dados.servico_info_complementar.length < 15) {
        //     form.info_complementar.nextElementSibling.style.display = "block"
        //     formValidado = false
        // }
        if (dados.servico_info_complementar === "") {
            dados.servico_info_complementar = null
        }
        // Atualizado 25/08/2025: Não vai ser possível informar essa campo na DPS.
        // if (dados.cidade_cod === 0) {
        //     form.cod_cidade_aux.nextElementSibling.style.display = "block"
        //     formValidado = false
        // } else {
        //     const cidade = filtros.cidades.filter((reg: any) => reg.cod_cidade === dados.cidade_cod)
        //     if (cidade.length > 0) {
        //         dados.cidade_descricao = cidade[0].nome
        //     }
        // }
        if (dados.servico_cidade_cod === 0) {
            form.cod_cidade_aux.nextElementSibling.style.display = "block"
            formValidado = false
        } else {
            const cidade = filtros.cidades.filter((reg: any) => reg.cod_cidade === dados.servico_cidade_cod)
            if (cidade.length > 0) {
                dados.servico_cidade_descricao = cidade[0].nome
                // Editado: 03/09/2025 Esse campo será definido pelo Sistema Nacional do NFSe
                // dados.cidade_descricao = cidade[0].nome
            }
        }
        if (dados.valor_servicos === "0.0") {
            form.valor.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.dps_data_competencia === "") {
            form.data_competencia.nextElementSibling.style.display = "block"
            formValidado = false
        }

        console.log(dados)

        if (!formValidado) {
            return
        }

        if (dados.id_nota === null) {
            formCadastrar(dados)
            return
        }
        if (dados.id_nota !== null) {
            formEditar(dados)
            return
        }

    }

    async function formCadastrar(dados: NFSeCadastrarDto) {
        setLoading(true)
        const api = await reqPut(ApiEndpoints.nfseCadastrar, dados)
        if (api.status === 201) {
            nota = api.data
            toast.success('NFSe cadastrada com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            // handleUpdateNfs()
            // loadNota(api.data)
            // setNotaDados(api.data)
            window.history.replaceState("OB PORTUS .NET", "OB PORTUS EMPRESA NF", `/nfse?id_empresa=${empresa.id_empresa}&id_nota=${api.data.id}`)
            // window.history.pushState("OB PORTUS .NET", "OB PORTUS EMPRESA NF", `/nfse?id_empresa=${empresa.id_empresa}&id_nota=${nota.id}`)
            setNotaDados(api.data)
            carregarNota(api.data)
            setNotaFoiEditada(true)
        }
        setLoading(false)
    }
    async function formEditar(dados: NFSeCadastrarDto) {
        setLoading(true)
        const api = await reqPatch(ApiEndpoints.nfseEditar, dados)
        if (api.status === 200) {
            nota = api.data
            toast.success('NFSe editada com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            setNotaDados(api.data)
            carregarNota(api.data)
            setNotaFoiEditada(true)
        }
        setLoading(false)
    }
    async function formDeletar() {
        if (!window.confirm("Tem certeza que deseja excluir?")) {
            return
        }
        const dados = {
            id_nota: notaDados.id,
        }
        setLoading(true)
        const api = await reqPostNew(ApiEndpoints.nfseDeletar, dados)
        if (api.status === 200) {
            nota = api.data
            toast.success('NFSe deletada com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            handleSairNota({ atualizar: true })
        }
        setLoading(false)
    }
    async function formDownload(filetype: "xml" | "pdf", notaDados: any) {
        setLoading(true)
        const urlAux = filetype === "xml" ? "xmlsign" : "danfse"
        const chave = urlAux === "danfse" ? notaDados.id_chave : notaDados.id
        const urlNota: LinkEndpoint = {
            endpoint: ApiEndpoints.apiNew + `/nfse/${urlAux}/${chave}`,
            timeout: 10000,
        }
        let filename = `NFSe ${notaDados.nNFSe} - ${notaDados.cidade_descricao} - ${notaDados.valor_servicos} - ${notaDados.id_cliente.nome}.${filetype}`
        if (urlAux === "xmlsign") {
            filename = `DPS NFID-${notaDados.id} - ${notaDados.cidade_descricao} - ${notaDados.valor_servicos} - ${notaDados.id_cliente.nome}.${filetype}`
        }
        const api = await reqGetDownloadFile(urlNota, filename)
        if (api.status === 200) {
            toast.success('Download realizado!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        if (api.status !== 200) {
            toast.error('Erro Download!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        setLoading(false)
    }
    async function formDownloadXML() {
        setLoading(true)
        const urlNota: LinkEndpoint = {
            endpoint: ApiEndpoints.apiNew + `/nfse/xml/${notaDados.id_chave}`,
            timeout: 10000,
        }
        const filename = `NFSe ${notaDados.nNFSe} - ${notaDados.cidade_descricao} - ${notaDados.valor_servicos} - ${notaDados.id_cliente.nome}.xml`
        const api = await reqGetDownloadFile(urlNota, filename)
        if (api.status === 200) {
            toast.success('Download realizado!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        if (api.status !== 200) {
            toast.error('Erro Download!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        setLoading(false)
    }
    async function formEmitir() {
        if (!window.confirm("Tem certeza que deseja emitir?")) {
            return
        }
        const formulario_nao_foi_salvo = handleVerififyChanges()
        if (!formulario_nao_foi_salvo) {
            toast.warning(`Houve alterações no formulário não salvas!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            return
        }
        let descriminacao = getValueFromInput("descriminacao")
        let possuiInfoSemEditar = descriminacao.search("#obs#")
        if (possuiInfoSemEditar >= 0) {
            toast.warning("Há informações que precisam ser informadas na descrição da NF! #obs#", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            return
        }
        let info_complementar = getValueFromInput("info_complementar")
        let possuiInfoSemEditarInfo = info_complementar.search("#obs#")
        if (possuiInfoSemEditarInfo >= 0) {
            toast.warning("Há informações que precisam ser informadas na descrição complementar da NF! #obs#", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            return
        }
        setLoading(true)
        const aliquotaIss = await consultarISS(false)
        if (empresa.nfs_situacao_simp_nac === 1) {
            if (!aliquotaIss.consulta_realizada) {
                toast.warning(`ERRO AO CONSULTAR ISS, VERIQUE COM O SUPORTE!`, {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
                setLoading(false)
                return
            }

            const iss = aliquotaIss.aliquota
            if (iss !== null) {
                const issNota = Number(notaDados.ISS)
                if (issNota !== iss) {
                    toast.warning(`Atualize o ISS = ${String(iss)}!`, {
                        containerId: 1,
                        position: 'top-center',
                        theme: 'dark'
                    })
                    setLoading(false)
                    return
                }
            }
        }
        if (notaDados.ISS === "0.00" && bloquearISS === false) {
            if (!window.confirm("O ISS não foi informado, CONTINUAR?")) {
                setLoading(false)
                return
            }
        }
        const urlEmitir: LinkEndpoint = {
            endpoint: ApiEndpoints.apiNew + `/nfse/emitir/${notaDados.id}`,
            timeout: 30000,
        }
        const opcoesEmitir = {
            informar_iss: aliquotaIss.informar_iss,
        }
        const api = await reqPostNew(urlEmitir, opcoesEmitir)
        if (api.status === 200) {
            nota = api.data.nota
            setNotaDados(api.data.nota)
            carregarNota(api.data.nota)
            setNotaFoiEditada(true)
            if (api.data.response.status_code === 201) {
                toast.success('NFSe emitida com sucesso!', {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
                toast.info('Aguarde download!', {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
                await sleep(1000)
                await formDownload("pdf", api.data.nota)
            } else {
                setShowModalErroEmissao(true)
                setModalErroEmissaoResponse(JSON.stringify(api.data.response, null, 4))
            }
        }
        setLoading(false)
    }
    async function consultarISS(mostrarModal: boolean): Promise<NFSeIss> {
        if (empresa.nfs_situacao_simp_nac === 3) {
            if (mostrarModal) { 
                toast.warning('Empresa Obtante pelo Simples Nacional!', {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            }
            return {
                aliquota: Number(empresa.nfs_ISS),
                informar_iss: true,
                consulta_realizada: true,
            }
        }
        let servico_cod_mun = "000"
        if (notaDados.servico_cod_mun !== null && notaDados.servico_cod_mun !== "") {
            servico_cod_mun = notaDados.servico_cod_mun
        }
        let dados = {
            "cod_cidade": notaDados.servico_cidade_cod,
            "cod_servico": notaDados.servico_cod,
            "cod_servico_mun": servico_cod_mun,
            "data_competencia": notaDados.dps_data_competencia,
        }
        if (mostrarModal) { 
            const cod_servico_input = idServico.value
            const id_servico_mun_input = Number(idServicoMun.value)
            const cod_servico_mun = filtros.servicos_mun.filter((reg: any) => reg.id === id_servico_mun_input)
            const cod_servico_mun_input = cod_servico_mun.length > 0 ? cod_servico_mun[0].servico_cod_mun : "000"
            const cod_cidade_input = Number(codCidade.value)
            if (dados.cod_cidade !== cod_cidade_input && cod_cidade_input > 0) { 
                dados.cod_cidade = cod_cidade_input
            }
            if (dados.cod_servico !== cod_servico_input && Number(cod_servico_input) > 0) { 
                dados.cod_servico = cod_servico_input
            }
            if (dados.cod_servico_mun !== cod_servico_mun_input && Number(cod_servico_mun_input) > 0) { 
                dados.cod_servico_mun = cod_servico_mun_input
            }
        }
        
        if (mostrarModal) { setLoading(true) }
        const api = await reqPostNew(ApiEndpoints.nfseConsultarISS, dados)
        if (mostrarModal) { setLoading(false) }
        if (mostrarModal) { 
            setModalConsultarISSResponse(api.data)
            setShowModalConsultarISS(true)
        }

        let informar_iss = false
        if (api.status === 200) {
            const iss = api.data
            if (iss.response.status_code === 200) {
                const key: string = Object.keys(iss.response.data.aliquotas)[0]
                const aliquota = iss.response.data.aliquotas[key][0].Aliq
                return {
                    aliquota: Number(aliquota),
                    informar_iss: informar_iss,
                    consulta_realizada: api.status === 200,
                }
            } else {
                informar_iss = true
            }
        }
        return {
            aliquota: null,
            informar_iss: informar_iss,
            consulta_realizada: api.status === 200,
        }
    }
    interface NFSeIss {
        aliquota: number | null,
        informar_iss: boolean,
        consulta_realizada: boolean,
    }
    async function handleCancelar() {
        setShowModalCancelar(true)
        // if (!window.confirm("Tem certeza que deseja cancelar?")) {
        //     return
        // }
        // const data_atual = dayjs()
        // const data_emitido = dayjs(notaDados.data_emissao)
        // const diff = data_atual.diff(data_emitido, "days")
        // const qtd_maxima_dias = 15
        // if (diff > qtd_maxima_dias) {
        //     window.alert(`Nota não pode ser cancelada após ${qtd_maxima_dias} dias da emissão!`)
        //     return
        // }
        // setLoading(true)
        // const dados = {
        //     id_nota: notaDados.id,
        // }
        // const api = await reqPostNew(ApiEndpoints.nfseCancelar, dados)
        // if (api.status === 200) {
        //     nota = api.data
        //     toast.success('NFSe Cancelada com sucesso!', {
        //         containerId: 1,
        //         position: 'top-center',
        //         theme: 'dark'
        //     })
        //     window.alert("LEMBRETE: Faça o cancelamento via site do governo!")
        //     nota = api.data
        //     setNotaDados(api.data)
        //     carregarNota(api.data)
        //     setNotaFoiEditada(true)
        // }
        // setLoading(false)
    }
    async function handleModalCancelarEvento(api: any) {
        if (api.status === 200) {
            setShowModalCancelar(false)
            nota = api.data.nota
            setNotaDados(api.data.nota)
            carregarNota(api.data.nota)
            setNotaFoiEditada(true)
            if (api.data.response.status_code === 201) {
                toast.success('NFSe Cancelada com sucesso!', {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            } else {
                setShowModalErroEmissao(true)
                setModalErroEmissaoResponse(JSON.stringify(api.data.response, null, 4))
            }
        }
    }
    async function handleModalCancelar(api: any) {
        if (api.status === 200) {
            setShowModalCancelar(false)
            nota = api.data
            toast.success('NFSe Cancelada com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            nota = api.data
            setNotaDados(api.data)
            carregarNota(api.data)
            setNotaFoiEditada(true)
        }
    }

    function handleBtnFecharNota() {
        if (Object.values(notaDados).length > 0) {
            const formulario_nao_foi_salvo = handleVerififyChanges()
            if (!formulario_nao_foi_salvo) {
                if (!window.confirm("Houve alterações no formulário não salvas, deseja descartar?")) {
                    return
                }
                // toast.warning(`Houve alterações no formulário não salvas!`, {
                //     containerId: 1,
                //     position: 'top-center',
                //     theme: 'dark'
                // })
                // return
            }
        } else {
            if (!window.confirm("Nota não foi criada, deseja descartar?")) {
                return
            }
        }

        handleSairNota({ atualizar: notaFoiEditada })
    }
    function handleServiceMun(cidade_cod: number) {
        const servicos_mun:any[] = filtros.servicos_mun.filter((reg:any) => reg.cidade_cod === cidade_cod)
        setIdServicoMun({ "value": "0", "label": "Não Selecionado" })
        if (servicos_mun.length > 0) {
            setShowServicoMun(true)
            let servicosAux = servicos_mun.map((item: any, index: any) => (
                {
                    "value": `${item.id}`,
                    "label": `#${item.servico_cod}-${item.servico_cod_mun} ${item.servico_descricao}`
                }
            ))
            setIdServicoFiltroMun(servicosAux)
        } else {
            setShowServicoMun(false)
        }
    }

    return (
        <div>
            <NFSeModalEmissaoErro
                show={showModalErroEmissao}
                handleClose={() => { setShowModalErroEmissao(false); setModalErroEmissaoResponse({}) }}
                errorData={modalErroEmissaoResponse}
            />
            <NFSeModalVisualizarISSConsulta
                show={showModalConsutarISS}
                cidadeData={codCidade}
                servicoData={idServico}
                handleClose={() => { setShowModalConsultarISS(false); setModalConsultarISSResponse({}) }}
                issData={modalConsultarISSResponse}
            />
            <LoadingModal show={loading} handleClose={(event: any) => { setLoading(!loading) }} />
            { Object.values(notaDados).length > 0 && <ModalCancelarNfse show={showModalCancelar} handleClose={() => { setShowModalCancelar(false) }} nota={notaDados} handleCancelar={handleModalCancelar} handleCancelarEvento={handleModalCancelarEvento} /> }
            <Form id='formNFSe' onSubmit={handleSubmit} noValidate>
                <div style={{ display: "flex" }}>
                    <div className={styles.painelEmpresaLogo} onClick={() => { handleBtnFecharNota() }} style={{ width: "430px", maxWidth: "430px", minWidth: "430px" }}>
                        {empresa.id_empresa === 1 && <img src={r2slogo} about="LOGO" alt="LOGO"></img>}
                        {empresa.id_empresa > 1 && <img src={oblogo} about="LOGO" alt="LOGO"></img>}
                        <h2>{empresa.nome}</h2>
                    </div>
                    <div id={styles.painelEmpresaCliente}>
                        <div id={styles.painelEmpresaNota} style={{ width: "35%" }}>
                            <p style={{ fontWeight: "bold" }}>EMITENTE</p>
                            <DetalhesEmpresa empresa={empresa} nota={notaDados} />
                        </div>
                        <div id={styles.painelClienteNota} style={{ width: "35%" }}>
                            <p style={{ fontWeight: "bold" }}>TOMADOR</p>
                            <DetalhesCliente clientes={filtros.clientes} selecionado={idCliente} />
                        </div>
                        <div className="div-row mb-15-forms" style={{ width: "30%", justifyContent: "flex-end" }}>
                            {(notaDados.status !== "Emitido" && notaDados.status !== "Emitido (Cancelado)") && <Button onClick={() => { }} type="submit" variant="success" style={{ marginLeft: "10px", height: "50px" }}>Salvar</Button>}
                            {(notaDados.status !== "Emitido" && notaDados.status !== "Emitido (Cancelado)" && Object.values(notaDados).length > 0) && <Button onClick={() => { formEmitir() }} variant="warning" style={{ marginLeft: "10px", height: "50px" }}>Emitir</Button>}
                            {(notaDados.status !== "Emitido" && notaDados.status !== "Emitido (Cancelado)" && Object.values(notaDados).length > 0) && <Button onClick={() => { formDeletar() }} variant="danger" style={{ marginLeft: "10px", height: "50px" }}>Deletar Nota</Button>}

                            {((notaDados.status === "Emitido" || notaDados.status === "Emitido (Cancelado)") && Object.values(notaDados).length > 0) && <Button onClick={() => { formDownloadXML() }} variant='success' style={{ height: '50px', marginLeft: '10px' }} className='div-row-space-between'><span className="material-symbols-outlined">code_blocks</span></Button>}
                            {((notaDados.status === "Emitido" || notaDados.status === "Emitido (Cancelado)") && Object.values(notaDados).length > 0) && <Button onClick={() => { formDownload("pdf", notaDados) }} variant='success' style={{ height: '50px', marginLeft: '10px' }} className='div-row-space-between'><span className="material-symbols-outlined">docs</span></Button>}
                            {((notaDados.status === "Emitido" || notaDados.status === "Emitido (Cancelado)" || notaDados.status === "Erro ao Emitir") && Object.values(notaDados).length > 0) && <Button onClick={() => { formDownload("xml", notaDados) }} variant='secondary' style={{ height: '50px', marginLeft: '10px' }} className='div-row-space-between'><span className="material-symbols-outlined">code_blocks</span></Button>}
                            {(notaDados.status === "Emitido" && Object.values(notaDados).length > 0 && notaPodeCancelar) && <Button onClick={() => { handleCancelar() }} variant="danger" style={{ marginLeft: "10px", height: "50px" }}>Cancelar Nota</Button>}
                        </div>
                    </div>
                </div>

                <br></br>

                <IdentificacaoNFSe show={Object.values(notaDados).length > 0} nota={notaDados} />
                <EventosNFSe show={Object.values(notaDados).length > 0} nota={notaDados} />

                <Row className={styles.identificacao_nfse}>
                    <h2 id={styles.identificacao_nfse_title} style={{ marginBottom: "0px" }}>Cliente e Serviço</h2>
                </Row>

                <Row className="mb-15-forms"> {/* Cliente - Data Competência - Serviço */}
                    <Col className='col-4'>
                        <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Tomador:</Form.Label>
                            <Select name='id_cliente' id='id_cliente' options={idClienteFiltro} value={idCliente} isDisabled={isFormDisabled} placeholder="Selecione o Cliente" onChange={
                                (choice: any) => {
                                    setIdCliente(choice)
                                    setCarregarNotas(false)
                                    const cliente: any = clientesFiltro.filter((reg: any) => reg.id_cliente === Number(choice.value))[0]
                                    if (cliente.id_tipo_cliente === 2) {
                                        defineValueInInput("situacao_pis_cofins", "1")
                                    }
                                    if (empresa.nfs_situacao_simp_nac === 1) {
                                        let tipo_cliente = filtros.clientes_tipos.filter((reg: any) => reg.id_tipo_cliente === cliente.id_tipo_cliente)[0]
                                        defineValueInInput("IRRF", formatarPorcentagem(tipo_cliente.IRRF))
                                        handleCalcTributo("IRRF")
                                        defineValueInInput("INSS", formatarPorcentagem(tipo_cliente.INSS))
                                        handleCalcTributo("INSS")
                                        defineValueInInput("COFINS", formatarPorcentagem(tipo_cliente.COFINS))
                                        handleCalcTributo("COFINS")
                                        defineValueInInput("CSLL", formatarPorcentagem(tipo_cliente.CSLL))
                                        handleCalcTributo("CSLL")
                                        defineValueInInput("PIS", formatarPorcentagem(tipo_cliente.PIS))
                                        handleCalcTributo("PIS")
                                        toast.info(`Tipo de Cliente selecionado: ${tipo_cliente.nome}!`, {
                                            containerId: 1,
                                            position: 'top-center',
                                            theme: 'dark',
                                            autoClose: 2000,
                                        })
                                        let cidade = filtros.cidades.filter((reg: any) => reg.cod_cidade === cliente.cod_cidade)
                                        if (cidade.length > 0) {
                                            cidade = cidade[0]
                                            setCodCidade({
                                                "value": `${cidade.cod_cidade}`,
                                                "label": `${cidade.nome}/${cidade.uf}`
                                            })
                                            defineValueInInput("ISS", formatarPorcentagem(cidade.iss))
                                            setTributoISSAux(formatarPorcentagem(cidade.iss))
                                            handleCalcTributo("ISS")
                                            // Atualizado 25/08/2025: Não vai ser possível informar essa campo na DPS.
                                            // setCodCidadeIss({
                                            //     "value": `${cidade.cod_cidade}`,
                                            //     "label": `${cidade.nome}/${cidade.uf}`
                                            // })
                                        }
                                    }
                                    if (empresa.nfs_situacao_simp_nac === 3) {
                                        let cidade = filtros.cidades.filter((reg: any) => reg.cod_cidade === cliente.cod_cidade)
                                        if (cidade.length > 0) {
                                            cidade = cidade[0]
                                            setCodCidade({
                                                "value": `${cidade.cod_cidade}`,
                                                "label": `${cidade.nome}/${cidade.uf}`
                                            })
                                            // Atualizado 25/08/2025: Não vai ser possível informar essa campo na DPS.
                                            // setCodCidadeIss({
                                            //     "value": `${cidade.cod_cidade}`,
                                            //     "label": `${cidade.nome}/${cidade.uf}`
                                            // })
                                        }
                                    }
                                    handleCalcValorLiquido()
                                }
                            } styles={customSelectStylesNfs} />
                            <Form.Control name='id_cliente_aux' type="text" id='id_cliente_aux' placeholder="" style={{ display: "none" }} />
                            <Form.Control.Feedback type="invalid">
                                Informe o Cliente!
                            </Form.Control.Feedback>
                        </Form.Group>
                        <ClienteUltimasNotasEmitidas empresa={empresa} id_cliente={Number(idCliente.value)} carregarNotas={carregarNotas} handleCarregarNotas={(status: any) => { setCarregarNotas(status) }} />
                    </Col>
                    <Col className='col-2'>
                        <Form.Group>
                            <Form.Label>Data Competência:</Form.Label>
                            <Form.Control name='data_competencia' type="date" id='data_competencia' disabled={isFormDisabled} />
                            <Form.Control.Feedback type="invalid">
                                Informe a data da competência!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className={showServicoMun ? 'col-4' : 'col-6'} styles={{position: "relative !important"}}>
                        <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Serviço:</Form.Label>
                            <Select name='id_servico' id='id_servico' options={idServicoFiltro} value={idServico} isDisabled={isFormDisabled} placeholder="Selecione o Serviço" onChange={
                                (choice: any) => {
                                    setIdServico(choice)
                                    let servico = filtros.servicos.filter((reg: any) => reg.servico_cod === choice.value)[0]
                                    const situacao_tributos = servico.tributos_situacao === 1 ? "Retido" : "Tributado"
                                    const situacao_tributos_cod = servico.tributos_situacao === 1 ? 2 : 1
                                    defineValueInInput("situacao_tributos", situacao_tributos_cod)
                                    const clientes: any[] = clientesFiltro.filter((reg: any) => reg.id_cliente === Number(idCliente.value))
                                    if (clientes.length > 0) {
                                        const cliente = clientes[0]
                                        if (cliente.id_tipo_cliente === 2) {
                                            defineValueInInput("situacao_pis_cofins", "0")
                                        } else {
                                            defineValueInInput("situacao_pis_cofins", servico.tributos_situacao === 1 ? "3" : "0")
                                        }
                                    } else {
                                        defineValueInInput("situacao_pis_cofins", servico.tributos_situacao === 1 ? "3" : "0")
                                    }

                                    handleChangeSituacaoTributos(situacao_tributos)

                                    handleCalcTributos()
                                }
                            } styles={customSelectStylesNfs} />
                            <Form.Control name='id_servico_aux' type="text" id='id_servico_aux' placeholder="" style={{ display: "none" }} />
                            <Form.Control.Feedback type="invalid">
                                Informe o Serviço!
                            </Form.Control.Feedback>
                            {servicoObs !== "" && <p style={{ marginTop: "10px" }}>{servicoObs}</p>}
                        </Form.Group>
                        <Form.Group id={styles.show_servico_nbs}>
                            <input type="checkbox" id="servico_nbs" name="servico_nbs" defaultChecked={showServicoNBS} checked={showServicoNBS} onChange={() => setShowServicoNBS(!showServicoNBS)} disabled={isFormDisabled} />
                            <Form.Label htmlFor="servico_nbs">Declarar informações NBS?</Form.Label>
                        </Form.Group>
                    </Col>
                    {
                        showServicoMun &&
                        <Col className="col-2">
                            <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Serviço Municipal:</Form.Label>
                                <Select name='id_servico_mun' id='id_servico_mun' options={idServicoFiltroMun} value={idServicoMun} isDisabled={isFormDisabled} placeholder="Selecione o Serviço" onChange={
                                    (choice: any) => {
                                        setIdServicoMun(choice)
                                    }
                                } styles={customSelectStylesNfs} />
                            </Form.Group>
                        </Col>
                    }
                </Row>

                

                <div style={{display: showServicoNBS ? "block" : "none"}}>
                    <Row className={styles.identificacao_nfse}>
                        <h2 id={styles.identificacao_nfse_title} style={{ marginBottom: "0px" }}>Informações NBS</h2>
                    </Row>

                    <Row className="mb-15-forms">
                        <Col className="col-3">
                            <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Item da NBS correspondente ao serviço prestado:</Form.Label>
                                <Select name='servico_nbs_cod' id='servico_nbs_cod' options={NFSE_NBS_OPTIONS} value={idServicoNBS} isDisabled={isFormDisabled} placeholder="Selecione o Serviço NBS" onChange={
                                    (choice: any) => {
                                        setIdServicoNBS(choice)
                                    }
                                } styles={customSelectStylesNfs} />
                                <Form.Control name='servico_nbs_cod_aux' type="text" id='servico_nbs_cod_aux' placeholder="" style={{ display: "none" }} />
                                <Form.Control.Feedback type="invalid">
                                    Informe o item da NBS!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col className="col-3">
                            <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Código indicador da operação:</Form.Label>
                                <Select name='IBSCBS_operacao_cod' id='IBSCBS_operacao_cod' options={NFSE_NBS_OPERACAO_COD_OPTIONS} value={idIBSCBSOperacaoCod} isDisabled={isFormDisabled} placeholder="Selecione o Serviço NBS" onChange={
                                    (choice: any) => {
                                        setIdIBSCBSOperacaoCod(choice)
                                    }
                                } styles={customSelectStylesNfs} />
                                <Form.Control name='IBSCBS_operacao_cod_aux' type="text" id='IBSCBS_operacao_cod_aux' placeholder="" style={{ display: "none" }} />
                                <Form.Control.Feedback type="invalid">
                                    Informe o código indicador da operação!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col className="col-3">
                            <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Código de Situação Tributária:</Form.Label>
                                <Select name='IBSCBS_cst_cod' id='IBSCBS_cst_cod' options={NFSE_NBS_CST_OPTIONS} value={idIBSCBSCstCod} isDisabled={isFormDisabled} placeholder="Selecione o Serviço NBS" onChange={
                                    (choice: any) => {
                                        setIdIBSCBSCstCod(choice)
                                    }
                                } styles={customSelectStylesNfs} />
                                <Form.Control name='IBSCBS_cst_cod_aux' type="text" id='IBSCBS_cst_cod_aux' placeholder="" style={{ display: "none" }} />
                                <Form.Control.Feedback type="invalid">
                                    Informe o Código de Situação Tributária!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col className="col-3">
                            <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Código de Classificação Tributária:</Form.Label>
                                <Select name='IBSCBS_class_trib_cod' id='IBSCBS_class_trib_cod' options={NFSE_NBS_CLASS_TRIB_OPTIONS} value={idIBSCBSClassTribCod} isDisabled={isFormDisabled} placeholder="Selecione o Serviço NBS" onChange={
                                    (choice: any) => {
                                        setIdIBSCBSClassTribCod(choice)
                                    }
                                } styles={customSelectStylesNfs} />
                                <Form.Control name='IBSCBS_class_trib_cod_aux' type="text" id='IBSCBS_class_trib_cod_aux' placeholder="" style={{ display: "none" }} />
                                <Form.Control.Feedback type="invalid">
                                    Informe o Classificação Tributária!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                </div>

                <Row className={styles.identificacao_nfse}>
                    <h2 id={styles.identificacao_nfse_title} style={{ marginBottom: "0px" }}>Valores</h2>
                </Row>

                <Row className="mb-15-forms"> {/* Valor - Situação de Tributos (RETIDO OU NAO) - Cidade - ISS */}
                    {/* <h2 id={styles.identificacao_nfse_title}>Valores</h2> */}
                    <Col className="col-4">
                        <Form.Group>
                            <Form.Label>Valor:</Form.Label>
                            <Form.Control name='valor' type="text" id='valor' className='dinheiro' autoComplete='off' placeholder="0,00" disabled={isFormDisabled} style={{ fontWeight: "bold" }} onKeyUp={handleChangeInValor} />
                            <Form.Control.Feedback type="invalid">
                                Informe o valor da NF!
                            </Form.Control.Feedback>
                            <Form.Control name='dinheiro_aux' type="text" id='dinheiro_aux' className='dinheiro' placeholder="0,00" style={{ display: "none" }} />
                            <Form.Control name='porcentagem_aux' type="text" id='porcentagem_aux' className='porcentagem' placeholder="0.00" style={{ display: "none" }} />
                        </Form.Group>
                    </Col>
                    <Col className='col-2' style={{display: "none"}}>
                        <Form.Group>
                            <Form.Label>Situação Alíquota (ISS):</Form.Label>
                            <Form.Select name="situacao_tributos" id="situacao_tributos" disabled={isFormDisabled} aria-label="Selecione o opção" onChange={
                                (event) => { 
                                    const value = Number(event.target.value)
                                    if (value > 0) {
                                        const situacao_tributos = value === 1 ? "Tributado" : "Retido"
                                        handleChangeSituacaoTributos(situacao_tributos)
                                    }
                                    handleCalcTributos()
                                }
                            }>
                                <option value="0">Selecione</option>
                                <option value="1">Tributado - ISS</option>
                                <option value="2">Retido - ISS</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Informe a Situação dos tributos!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    {/* <Col className='col-2'>
                        <Form.Group>
                            <Form.Label>Situação Tributos:</Form.Label>
                            <Form.Control name='situacao' type="text" id='situacao' readOnly disabled />
                            <Form.Control.Feedback type="invalid">
                                Informe a situação da NF!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col> */}
                    <Col className='col-4'>
                        <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Cidade Serviço:</Form.Label>
                            <Select name='cod_cidade' id='cod_cidade' options={codCidadeFiltro} value={codCidade} isDisabled={isFormDisabled} placeholder="Selecione a Cidade" onChange={
                                (choice: any) => {
                                    setCodCidade(choice)
                                    const cidade = filtros.cidades.filter((reg: any) => reg.cod_cidade === Number(choice.value))[0]
                                    if (empresa.nfs_situacao_simp_nac === 1) {
                                        defineValueInInput("ISS", formatarPorcentagem(cidade.iss))
                                        setTributoISSAux(formatarPorcentagem(cidade.iss))
                                        handleCalcTributo("ISS")
                                        handleCalcValorLiquido()
                                    }
                                    handleServiceMun(Number(choice.value))
                                }
                            } styles={customSelectStylesNfs} />
                            <Form.Control name='cod_cidade_aux' type="text" id='cod_cidade_aux' placeholder="" style={{ display: "none" }} />
                            <Form.Control.Feedback type="invalid">
                                Informe a Cidade!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    {/* <Col className='col-2'>
                        <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Cidade incidencia ISS:</Form.Label>
                            <Select name='cod_cidade_iss' id='cod_cidade_iss' options={codCidadeFiltro} value={codCidadeIss} isDisabled={isFormDisabled} placeholder="Selecione a Cidade" onChange={
                                (choice: any) => {
                                    setCodCidadeIss(choice)
                                    const cidade = filtros.cidades.filter((reg: any) => reg.cod_cidade === Number(choice.value))[0]
                                    if (empresa.nfs_situacao_simp_nac === 1) {
                                        defineValueInInput("ISS", formatarPorcentagem(cidade.iss))
                                        handleCalcTributo("ISS")
                                    }
                                }
                            } styles={customSelectStylesNfs} />
                            <Form.Control name='cod_cidade_aux' type="text" id='cod_cidade_aux' placeholder="" style={{ display: "none" }} />
                            <Form.Control.Feedback type="invalid">
                                Informe a Cidade!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col> */}
                    <Col className='col-2'>
                        <p className={styles.titleValorTributo} id='ISS_descricao'>ISS {Object.values(notaDados).length === 0 ? empresa.nfs_situacao_simp_nac === 3 && ` - SIMPLES NACIONAL` : notaDados.simples_nacional_op === 3 && ` - SIMPLES NACIONAL`}</p>
                        <div className={styles.divInputsTributo}>
                            <p>Aliquota (%)</p>
                            <input name='ISS' type="text" id='ISS' className='porcentagem' autoComplete='off' disabled={isFormDisabled || bloquearISS} placeholder="0.00" onKeyUp={(event: any) => {
                                setTributoISSAux(event.target.value)
                                handleChangeInTributo(event)
                            }} />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Valor (R$)</p>
                            <input name='ISS_V' type="text" id='ISS_V' placeholder="0,00" disabled={isValoresDisabled} />
                        </div>
                        {(nota.situacao_emissao === null || Object.values(nota).length === 0) && <div>
                            <p onClick={() => consultarISS(true)} style={{padding: "5px", border: "1px solid grey", cursor: "pointer", width: "max-content", marginBottom: "10px"}}>GovBR - Consultar ISS</p>
                        </div> }
                        <FormISSNFSE nota={notaDados} filtros={filtros} />
                    </Col>
                    <Col className='col-2'>
                        <FormSituacaoPISCOFINS nota={notaDados} isFormDisabled={isFormDisabled} />
                        {
                            !isFormDisabled &&
                            <div>
                                <br></br>
                                <Form.Check
                                    type="switch"
                                    id="editar_valores"
                                    label="Editar Valores"
                                    className={styles.inputCheck}
                                    onChange={() => { setIsValoresDisabled(!isValoresDisabled) }}
                                />
                            </div>
                        }
                    </Col>
                </Row>

                <Row className="mb-15-forms">  {/* Tributos: IRRF - INSS - COFINS - CSLL - PIS - LIQUIDO */}
                    <Col className='col-2'>
                        <p className={styles.titleValorTributo} id="IRRF_descricao">IRRF</p>
                        <div className={styles.divInputsTributo}>
                            <p>Aliquota (%)</p>
                            <input name='IRRF' type="text" id='IRRF' className='porcentagem' autoComplete='off' disabled={isFormDisabled} placeholder="0.00" onKeyUp={handleChangeInTributo} />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Valor (R$)</p>
                            <input name='IRRF_V' type="text" id='IRRF_V' placeholder="0,00" disabled={isValoresDisabled} />
                        </div>
                    </Col>
                    <Col className='col-2'>
                        <p className={styles.titleValorTributo} id="INSS_descricao">INSS (CP)</p>
                        <div className={styles.divInputsTributo}>
                            <p>Aliquota (%)</p>
                            <input name='INSS' type="text" id='INSS' className='porcentagem' autoComplete='off' disabled={isFormDisabled} placeholder="0.00" onKeyUp={handleChangeInTributo} />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Valor (R$)</p>
                            <input name='INSS_V' type="text" id='INSS_V' placeholder="0,00" disabled={isValoresDisabled} />
                        </div>
                    </Col>
                    <Col className='col-2'>
                        <p className={styles.titleValorTributo} id="CSLL_descricao">CSLL</p>
                        <div className={styles.divInputsTributo}>
                            <p>Aliquota (%)</p>
                            <input name='CSLL' type="text" id='CSLL' className='porcentagem' autoComplete='off' disabled={isFormDisabled} placeholder="0.00" onKeyUp={handleChangeInTributo} />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Valor (R$)</p>
                            <input name='CSLL_V' type="text" id='CSLL_V' placeholder="0,00" disabled={isValoresDisabled} />
                            <input name='CSLL_V2' type="text" id='CSLL_V2' placeholder="0,00" disabled={isValoresDisabled} style={{display: "none"}} />
                        </div>
                    </Col>
                    <Col className='col-2'>
                        <p className={styles.titleValorTributo} id="PIS_descricao">PIS</p>
                        <div className={styles.divInputsTributo}>
                            <p>Aliquota (%)</p>
                            <input name='PIS' type="text" id='PIS' className='porcentagem' autoComplete='off' disabled={isFormDisabled} placeholder="0.00" onKeyUp={handleChangeInTributo} />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Valor (R$)</p>
                            <input name='PIS_V' type="text" id='PIS_V' placeholder="0,00" disabled={isValoresDisabled} />
                        </div>
                    </Col>
                    <Col className='col-2'>
                        <p className={styles.titleValorTributo} id="COFINS_descricao">COFINS</p>
                        <div className={styles.divInputsTributo}>
                            <p>Aliquota (%)</p>
                            <input name='COFINS' type="text" id='COFINS' className='porcentagem' autoComplete='off' disabled={isFormDisabled} placeholder="0.00" onKeyUp={handleChangeInTributo} />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Valor (R$)</p>
                            <input name='COFINS_V' type="text" id='COFINS_V' placeholder="0,00" disabled={isValoresDisabled} />
                        </div>
                    </Col>
                    <Col className='col-2'>
                        <p className={styles.titleValorTributoResumo}>RESUMO</p>
                        <div className={styles.divInputsTributo}>
                            <p>Base (R$)</p>
                            <input name='BASE_V' type="text" id='BASE_V' placeholder="0,00" className='dinheiro' style={{ fontWeight: "bold" }} readOnly disabled />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Tributos (R$)</p>
                            <input name='TRIBUTOS_V' type="text" id='TRIBUTOS_V' placeholder="0,00" className='dinheiro' style={{ fontWeight: "bold" }} readOnly disabled />
                        </div>
                        <div className={styles.divInputsTributo}>
                            <p>Líquido (R$)</p>
                            <input name='LIQUIDO_V' type="text" id='LIQUIDO_V' placeholder="0,00" className='dinheiro' style={{ fontWeight: "bold" }} readOnly disabled />
                        </div>
                    </Col>
                </Row>
                <Row className="mb-15-forms" style={{marginTop: "-40px"}}>
                    <Col className="col-10 div-row" style={{textAlign: "center"}}>
                        <p style={{width: "100%"}}>
                            Tributos IRRF/INSS: R$ <span id="total_tributos_federais_outros" style={{marginRight: "25px"}}>0,00</span>
                            Contribuições Sociais: R$ <span id="total_contribuicoes_sociais" style={{marginRight: "25px"}}>0,00</span>
                            TOTAL TRIBUTOS FEDERAIS: R$ <span id="total_tributos_federais" style={{marginRight: "25px"}}>0,00</span>
                        </p>
                    </Col>
                </Row>

                <Row className="mb-15-forms">  {/* Descrição do Serviço NFSe */}
                    <Col className='col-6'>
                        <Form.Group className="mt-0 mb-3">
                            <Form.Label>Descrição do Serviço:</Form.Label>
                            <Form.Control as="textarea" rows={8} maxLength={1000} name='descriminacao' id='descriminacao' autoComplete='off' disabled={isFormDisabled} />
                            <Form.Control.Feedback type="invalid">
                                Preencha a descrição do serviço!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className='col-6'>
                        <Form.Group className="mt-0 mb-3">
                            <Form.Label>Informações Complementares:</Form.Label>
                            <Form.Control as="textarea" rows={8} maxLength={2000} name='info_complementar' id='info_complementar' autoComplete='off' disabled={isFormDisabled} />
                            <Form.Control.Feedback type="invalid">
                                Preencha as informações complementares!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-12">
                        <Form.Label style={{ color: "grey" }}>Opcional #obs# no texto, antes da emissão das notas será verificado se todas as OBSERVAÇÕES foram editadas.</Form.Label><br></br>
                        <Form.Label style={{ color: "grey" }}>Opcional preencher valores: #IRRF#, #INSS#, #COFINS#, #CSLL#, #PIS#, #ISS#, #VALOR#, #TRIBUTOS# e #LIQUIDO#. Valores serão preenchidos automaticamente após a emissão.</Form.Label>
                    </Col>
                </Row>

            </Form>


        </div>
    )
}
interface iViewNotaPageProps {
    empresa: any
    nota: any | null
    handleSairNota: any
    filtros: any
    modelo: any
}

interface iPropsFormSituacaoPisCofins {
    nota: any
    isFormDisabled: boolean
}
function FormSituacaoPISCOFINS({nota, isFormDisabled}: iPropsFormSituacaoPisCofins) {
    let versao = 2
    if (Object.values(nota).length > 0) {
        let data_criacao = dayjs(nota.data_criacao)
        let data_versao_1 = dayjs("2026-02-11 00:00:00")
        if (data_criacao.isBefore(data_versao_1) && nota.situacao_emissao === 100) {
            versao = 1
        }
        if (data_criacao.isSameOrAfter(data_versao_1)) {
            versao = 2
        }
    }

    if (versao === 2) {
        return (
            <Form.Group>
                <Form.Label>Situação CSLL/PIS/COFINS:</Form.Label>
                <Form.Select name="situacao_pis_cofins" id="situacao_pis_cofins" disabled={isFormDisabled} aria-label="Selecione o opção" onChange={() => { handleCalcTributos() }}>
                    <option value="99">Não informar</option>
                    <option value="0">PIS/COFINS/CSLL Tributados</option>
                    <option value="1">PIS/COFINS Retido</option>
                    <option value="2">PIS/COFINS Tributado</option>
                    <option value="3">PIS/COFINS/CSLL Retidos</option>
                    <option value="4">PIS/COFINS Retidos, CSLL Tributado</option>
                    <option value="5">PIS Retido, COFINS/CSLL Tributado</option>
                    <option value="6">COFINS Retido, PIS/CSLL Tributado</option>
                    <option value="7">PIS Tributado, COFINS/CSLL Retidos</option>
                    <option value="8">PIS/COFINS Tributados, CSLL Retido</option>
                    <option value="9">COFINS Tributado, PIS/CSLL Retidos</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                    Informe a Situação do PIS/COFINS!
                </Form.Control.Feedback>
            </Form.Group>
        )
    }
    return (
        <Form.Group>
            <Form.Label>Situação CSLL/PIS/COFINS:</Form.Label>
            <Form.Select name="situacao_pis_cofins" id="situacao_pis_cofins" disabled={isFormDisabled} aria-label="Selecione o opção" onChange={() => { handleCalcTributos() }}>
                <option value="0">Não informar</option>
                <option value="1">Retido</option>
                <option value="2">Tributado</option>
                <option value="3">PIS Retido / COFINS Tributado</option>
                <option value="4">PIS Tributado / COFINS Retido</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">
                Informe a Situação do PIS/COFINS!
            </Form.Control.Feedback>
        </Form.Group>
    )
}

function FormISSNFSE({ nota, filtros }: iPropsIssNfse) {
    if (Object.values(nota).length === 0) {
        return (
            <div></div>
        )
    }
    let cidadeSERVICOxISS: boolean = false
    const cidades: any[] = filtros.cidades.filter((reg: any) => reg.cod_cidade === nota.cidade_cod)
    let cidadeNome = ``
    if (nota.cidade_cod !== nota.servico_cidade_cod) { 
        cidadeSERVICOxISS = true
        if (cidades.length > 0) {
            const cidade: any = cidades[0]
            cidadeNome = `${cidade.nome}/${cidade.uf}`
        } else { 
            cidadeNome = `${nota.cidade_descricao}`
        }
    }
    let issOriginalDiferenteIssEmitido = nota.ISS_NFSE !== null && nota.ISS !== nota.ISS_NFSE
    if (cidadeSERVICOxISS === true && cidadeNome !== "null" && issOriginalDiferenteIssEmitido === false) {
        return (
            <div>
                <div>
                    <p style={{ marginBottom: "5px" }}><b>ISS ALTERADO PELO EMISSOR</b></p>
                    <p className={styles.titleValorTributo}>ISS CIDADE</p>
                    <p>{ cidadeNome }</p>
                </div>
            </div>
        )
    }
    if (!issOriginalDiferenteIssEmitido) { 
        return (<div></div>)
    }
    return (
        <div>
            <div>
                <p style={{ marginBottom: "5px" }}><b>ISS ALTERADO PELO EMISSOR</b></p>
                <div className={styles.divInputsTributo}>
                    <p><b>Aliquota (%)</b></p>
                    <input name='ISS_NFSE' type="text" id='ISS_NFSE' className='porcentagem' autoComplete='off' defaultValue={nota.ISS_NFSE} disabled placeholder="0.00" />
                </div>
                <div className={styles.divInputsTributo}>
                    <p><b>Valor (R$)</b></p>
                    <input name='ISS_V_NFSE' type="text" id='ISS_V_NFSE' autoComplete='off' defaultValue={formatarDinheiroFormatter(nota.ISS_V_NFSE)} disabled placeholder="0,00" />
                </div>
            </div>
            { (cidadeSERVICOxISS && cidadeNome !== "null") &&
                <div>
                    <p className={styles.titleValorTributo}>ISS CIDADE</p>
                    <p>{ cidadeNome }</p>
                </div>
            }
        </div>
    )
}
interface iPropsIssNfse { 
    nota: any
    filtros: any
}

const customSelectStylesNfs = {
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        borderColor: "#dee2e6",
        backgroundColor: state.isDisabled ? "#E9ECEF" : "white",
    }),
    singleValue: (provided: any, state: any) => ({
        ...provided,
        color: state.isDisabled ? "black" : "black",
    }),
}

export function getInputDinheiro(id: string): string {
    let input: any = document.getElementById(id)
    let value: string = input.value
    if (value === "") {
        value = "0,00"
    }
    return value.replaceAll(".", "").replaceAll(",", ".")
}
export function getInputPorcentagem(id: string): string {
    let input: any = document.getElementById(id)
    let value: string = input.value
    if (value === "" || value === "0") {
        value = "0.00"
    }
    return value
}
export function formatarDinheiro(valor: string): string {
    if (valor.indexOf("R$") >= 0) {
        valor = valor.replaceAll("R$ ", "")
        valor = valor.replaceAll(".", "")
        valor = valor.replaceAll(",", ".")
    }
    let ponto = valor.split(".")
    if (ponto.length > 1) {
        let casasDecimais = ponto[1]
        if (casasDecimais.length === 1) {
            valor = `${valor}0`
        }
    } else {
        valor = `${valor}.00`
    }
    defineValueInInput("dinheiro_aux", valor)
    return $("#dinheiro_aux").masked(valor)
}
export function formatarDinheiroFormatter(valor: string) {
    if (valor.indexOf("R$") >= 0) {
        valor = valor.replaceAll("R$ ", "")
        valor = valor.replaceAll(".", "")
        valor = valor.replaceAll(",", ".")
    }
    const moneyFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
    let valorf = moneyFormatter.format(Number(valor))
    valorf = String(valorf).substring(3)
    return valorf
}
export function formatarPorcentagem(valor: string): string {
    defineValueInInput("porcentagem_aux", valor)
    return $("#porcentagem_aux").masked(valor)
}
export function handleChangeInValor(event: any): void {
    handleCalcTributos()
    defineValueInInput("BASE_V", event.target.value)
}
export function handleChangeInTributo(event: any): void {
    handleCalcTributo(event.target.id)
    handleCalcValorLiquido()
}
export function handleCalcTributos() {
    let input_valor: any = document.getElementById("valor")
    if (input_valor.value === "") {
        return
    }
    handleCalcTributo("IRRF")
    handleCalcTributo("INSS")
    handleCalcTributo("COFINS")
    handleCalcTributo("CSLL")
    handleCalcTributo("PIS")
    handleCalcTributo("ISS")
    handleCalcValorLiquido()
}
export function handleCalcTributo(id_input_tributo: string) {
    let input_tributo: any = document.getElementById(id_input_tributo)
    let input_valor: any = document.getElementById("valor")
    if (input_valor.value === "") {
        return
    }
    let valor_nota_string: string = String(input_valor.value)
    let valor_nota: number = Number(valor_nota_string.replaceAll(".", "").replaceAll(",", "."))
    let valor_tributo: number = valor_nota * (Number(input_tributo.value) / 100)
    valor_tributo = NumbersRound(valor_tributo, 2)
    let input_tributo_valor: any = document.getElementById(`${id_input_tributo}_V`)
    input_tributo_valor.value = formatarDinheiro(valor_tributo.toString())
}
export function NumbersRound(number:number, precision:number): number {
    var factor = Math.pow(10, precision)
    var tempNumber = number * factor
    var roundedTempNumber = Math.round(tempNumber)
    return roundedTempNumber / factor
}
export function handleCalcValorLiquido() {
    let input_valor: any = document.getElementById("valor")
    if (input_valor.value === "") {
        return
    }
    let valor_nota_string: string = String(input_valor.value)
    let valor_nota: number = Number(valor_nota_string.replaceAll(".", "").replaceAll(",", "."))

    let inputIRRF: any = document.getElementById("IRRF")
    let IRRF: number = Number(valor_nota * (Number(inputIRRF.value) / 100))
    IRRF = NumbersRound(IRRF, 2)

    let inputINSS: any = document.getElementById("INSS")
    let INSS: number = Number(valor_nota * (Number(inputINSS.value) / 100))
    INSS = NumbersRound(INSS, 2)

    let inputCOFINS: any = document.getElementById("COFINS")
    let COFINS: number = Number(valor_nota * (Number(inputCOFINS.value) / 100))
    COFINS = NumbersRound(COFINS, 2)

    let inputCSLL: any = document.getElementById("CSLL")
    let CSLL: number = Number(valor_nota * (Number(inputCSLL.value) / 100))
    CSLL = NumbersRound(CSLL, 2)

    let inputPIS: any = document.getElementById("PIS")
    let PIS: number = Number(valor_nota * (Number(inputPIS.value) / 100))
    PIS = NumbersRound(PIS, 2)

    let inputISS: any = document.getElementById("ISS")
    
    // let ISS: number = Number(valor_nota * (Number(inputISS.value) / 100))
    let ISS: number = 0
    if (Number(inputISS.value) > 0) {
        ISS = Number(valor_nota * (Number(inputISS.value) / 100))
    }
    try {
        let inputISS_AUX: any = document.getElementById("ISS_NFSE")
        if (Number(inputISS_AUX.value) > 0) {
            ISS = Number(valor_nota * (Number(inputISS_AUX.value) / 100))
        }
    } catch (error) {}
    
    ISS = NumbersRound(ISS, 2)

    let tributos_status: any = document.getElementById("situacao_tributos")
    let pis_cofins_status: any = document.getElementById("situacao_pis_cofins")
    handleChangeTributosRetidos()

    let valor_impostos: number = 0
    let valor_csll = 0
    // 09/01/2025 - Ajustado para que o INSS e IRRF seja calculado normalmente, independente da situaçao dos tributos.
    valor_impostos += Number(INSS + IRRF)
    valor_impostos = NumbersRound(valor_impostos, 2)

    // Tributo ISS Retido
    if (tributos_status.value === "2") { 
        valor_impostos += Number(ISS)
        valor_impostos = NumbersRound(valor_impostos, 2)
    }

    // Tributos 1 - PIS/COFINS Retido
    if (pis_cofins_status.value === "1") {
        valor_csll = Number(PIS + COFINS)
        valor_impostos += Number(PIS + COFINS)
        valor_impostos = NumbersRound(valor_impostos, 2)
    }
    // Tributos 3 - PIS/COFINS/CSLL Retidos
    if (pis_cofins_status.value === "3") {
        valor_csll = Number(PIS + COFINS + CSLL)
        valor_impostos += Number(PIS + COFINS + CSLL)
        valor_impostos = NumbersRound(valor_impostos, 2)
    }
    // Tributos 4 - PIS/COFINS Retidos, CSLL Tributado
    if (pis_cofins_status.value === "4") {
        valor_csll = Number(PIS + COFINS)
        valor_impostos += Number(PIS + COFINS)
        valor_impostos = NumbersRound(valor_impostos, 2)
    }
    // Tributos 5 - PIS Retido, COFINS/CSLL Tributado
    if (pis_cofins_status.value === "5") {
        valor_csll = Number(PIS)
        valor_impostos += Number(PIS)
        valor_impostos = NumbersRound(valor_impostos, 2)
    }
    // Tributos 6 - COFINS Retido, PIS/CSLL Tributado
    if (pis_cofins_status.value === "6") {
        valor_csll = Number(COFINS)
        valor_impostos += Number(COFINS)
        valor_impostos = NumbersRound(valor_impostos, 2)
    }
    // Tributos 7 - PIS Tributado, COFINS/CSLL Retidos
    if (pis_cofins_status.value === "7") {
        valor_csll = Number(COFINS + CSLL)
        valor_impostos += Number(COFINS + CSLL)
        valor_impostos = NumbersRound(valor_impostos, 2)
    }
    // Tributos 9 - COFINS Tributado, PIS/CSLL Retidos
    if (pis_cofins_status.value === "9") {
        valor_csll = Number(PIS + CSLL)
        valor_impostos += Number(PIS + CSLL)
        valor_impostos = NumbersRound(valor_impostos, 2)
    }

    valor_csll = NumbersRound(valor_csll, 2)
    defineValueInInput("CSLL_V2", formatarDinheiro(valor_csll.toString()))
    handleCalcLegendaTributos()

    valor_impostos = valor_impostos >= valor_nota ? valor_nota : valor_impostos
    let input_valor_tributos: any = document.getElementById("TRIBUTOS_V")
    input_valor_tributos.value = formatarDinheiro(valor_impostos.toString())

    let valor_liquido: number = valor_nota - (valor_impostos)
    valor_liquido = NumbersRound(valor_liquido, 2)

    let input_valor_liquido: any = document.getElementById("LIQUIDO_V")
    input_valor_liquido.value = formatarDinheiro(valor_liquido.toString())
}
function handleCalcLegendaTributos() {
    let input_valor: any = document.getElementById("valor")
    if (input_valor.value === "") {
        return
    }
    let valor_nota_string: string = String(input_valor.value)
    let valor_nota: number = Number(valor_nota_string.replaceAll(".", "").replaceAll(",", "."))

    let inputIRRF: any = document.getElementById("IRRF")
    let IRRF: number = Number(valor_nota * (Number(inputIRRF.value) / 100))
    IRRF = NumbersRound(IRRF, 2)

    let inputINSS: any = document.getElementById("INSS")
    let INSS: number = Number(valor_nota * (Number(inputINSS.value) / 100))
    INSS = NumbersRound(INSS, 2)

    let inputCOFINS: any = document.getElementById("COFINS")
    let COFINS: number = Number(valor_nota * (Number(inputCOFINS.value) / 100))
    COFINS = NumbersRound(COFINS, 2)

    let inputCSLL: any = document.getElementById("CSLL")
    let CSLL: number = Number(valor_nota * (Number(inputCSLL.value) / 100))
    CSLL = NumbersRound(CSLL, 2)

    let inputPIS: any = document.getElementById("PIS")
    let PIS: number = Number(valor_nota * (Number(inputPIS.value) / 100))
    PIS = NumbersRound(PIS, 2)

    let valor_tributos_federais_outros: number = Number(INSS + IRRF)
    valor_tributos_federais_outros = NumbersRound(valor_tributos_federais_outros, 2)
    let valor_tributos_federais_outros_f: string = formatarDinheiro(valor_tributos_federais_outros.toString())
    defineTextInElementId("total_tributos_federais_outros", valor_tributos_federais_outros_f)

    let valor_csll: number = Number(PIS + COFINS + CSLL)
    valor_csll = NumbersRound(valor_csll, 2)
    let valor_csll_f: string = formatarDinheiro(valor_csll.toString())
    defineTextInElementId("total_contribuicoes_sociais", valor_csll_f)

    let valor_tributos_federais: number = Number(INSS + IRRF + PIS + COFINS + CSLL)
    valor_tributos_federais = NumbersRound(valor_tributos_federais, 2)
    let valor_tributos_federais_f: string = formatarDinheiro(valor_tributos_federais.toString())
    defineTextInElementId("total_tributos_federais", valor_tributos_federais_f)
}
function handleChangeTributosRetidos() {
    const VAZIO_LABEL = "#dedede"
    const IMPOSTO_ATIVO = "#b1cca6ff"
    const IMPOSTO_TRIBUTADO = "#e4e0b0ff"
    // const IMPOSTO_ATIVO = "#397cd3"

    let iss = VAZIO_LABEL
    let iss_descricao = getTextInElementId("ISS_descricao")
    let irrf = VAZIO_LABEL
    let irrf_descricao = "IRRF"
    let inss = VAZIO_LABEL
    let inss_descricao = "INSS (CP)"
    let csll = VAZIO_LABEL
    let csll_descricao = "CSLL"
    let pis = VAZIO_LABEL
    let pis_descricao = "PIS"
    let cofins = VAZIO_LABEL
    let cofins_descricao = "COFINS"

    // Tributos ISS
    let inputISS: any = document.getElementById("ISS_V")
    let ISS: number = Number(String(inputISS.value).replaceAll(".", "").replaceAll(",", "."))
    ISS = NumbersRound(ISS, 2)
    let inputISS_AUX: any = document.getElementById("ISS_V_NFSE")
    if (inputISS_AUX !== null) {
        let ISS_AUX: number = Number(String(inputISS_AUX.value).replaceAll(".", "").replaceAll(",", "."))
        ISS_AUX = NumbersRound(ISS_AUX, 2)
        if (ISS_AUX > 0) {
            iss = IMPOSTO_ATIVO
        }
    }
    if (ISS > 0) {
        iss = IMPOSTO_ATIVO
    }
    let tributos_status: any = document.getElementById("situacao_tributos")
    if (tributos_status.value === "2") { 
        let simples_nacional = iss_descricao.search("SIMPLES") > 0 ? " - SIMPLES NACIONAL" : ""
        iss_descricao = `ISS${simples_nacional} - RETIDO`
    } else {
        let simples_nacional = iss_descricao.search("SIMPLES") > 0 ? " - SIMPLES NACIONAL" : ""
        iss_descricao = `ISS${simples_nacional}`
    }
    if (tributos_status.value === "1") {
        iss = IMPOSTO_TRIBUTADO
        let simples_nacional = iss_descricao.search("SIMPLES") > 0 ? " - SIMPLES NACIONAL" : ""
        iss_descricao = `ISS${simples_nacional} - TRIBUTADO`
    }
    // Tributos IRRF
    let inputIRRF: any = document.getElementById("IRRF_V")
    let IRRF: number = Number(String(inputIRRF.value).replaceAll(".", "").replaceAll(",", "."))
    IRRF = NumbersRound(IRRF, 2)
    if (IRRF > 0) {
        irrf = IMPOSTO_ATIVO
        irrf_descricao = "IRRF - RETIDO"
    }
    // Tributos INSS
    let inputINSS: any = document.getElementById("INSS_V")
    let INSS: number = Number(String(inputINSS.value).replaceAll(".", "").replaceAll(",", "."))
    INSS = NumbersRound(INSS, 2)
    if (INSS > 0) {
        inss = IMPOSTO_ATIVO
        inss_descricao = "INSS (CP) - RETIDO"
    }
    // Tributos CSLL
    let inputCSLL: any = document.getElementById("CSLL_V")
    let CSLL: number = Number(String(inputCSLL.value).replaceAll(".", "").replaceAll(",", "."))
    CSLL = NumbersRound(CSLL, 2)
    if (CSLL > 0) {
        csll = IMPOSTO_ATIVO
    }
    // Tributos PIS
    let inputPIS: any = document.getElementById("PIS_V")
    let PIS: number = Number(String(inputPIS.value).replaceAll(".", "").replaceAll(",", "."))
    PIS = NumbersRound(PIS, 2)
    if (PIS > 0) {
        pis = IMPOSTO_ATIVO
    }
    // Tributos COFINS
    let inputCOFINS: any = document.getElementById("COFINS_V")
    let COFINS: number = Number(String(inputCOFINS.value).replaceAll(".", "").replaceAll(",", "."))
    COFINS = NumbersRound(COFINS, 2)
    if (COFINS > 0) {
        cofins = IMPOSTO_ATIVO
    }

    let pis_cofins_status: any = document.getElementById("situacao_pis_cofins")
    let versao_pis_cofins = pis_cofins_status.options.length === 11 ? 2 : 1
    if (versao_pis_cofins === 1) {
        // Tributos 1 - PIS/COFINS Retido
        if (pis_cofins_status.value === "1") {
            if (CSLL > 0) { csll = IMPOSTO_ATIVO;csll_descricao = "CSLL - RETIDO" }
            if (PIS > 0) { pis = IMPOSTO_ATIVO;pis_descricao = "PIS - RETIDO" }
            if (COFINS > 0) { cofins = IMPOSTO_ATIVO;cofins_descricao = "COFINS - RETIDO" }
        }
        // Tributos 2 - PIS/COFINS Tributado
        if (pis_cofins_status.value === "2") {
            if (PIS > 0) { pis = IMPOSTO_TRIBUTADO;pis_descricao = "PIS - TRIBUTADO" }
            if (COFINS > 0) { cofins = IMPOSTO_TRIBUTADO;cofins_descricao = "COFINS - TRIBUTADO" }
            if (CSLL > 0) { csll = IMPOSTO_TRIBUTADO;csll_descricao = "CSLL - TRIBUTADO" }
        }
        // Tributos 3 - PIS Retido/COFINS Tributado;
        if (pis_cofins_status.value === "2") {
            if (PIS > 0) { pis = IMPOSTO_ATIVO;pis_descricao = "PIS - RETIDO" }
            if (COFINS > 0) { cofins = IMPOSTO_TRIBUTADO;cofins_descricao = "COFINS - TRIBUTADO" }
            if (CSLL > 0) { csll = IMPOSTO_TRIBUTADO;csll_descricao = "CSLL - TRIBUTADO" }
        }
        // Tributos 4 - PIS Tributado/COFINS Retido;
        if (pis_cofins_status.value === "2") {
            if (PIS > 0) { pis = IMPOSTO_TRIBUTADO;pis_descricao = "PIS - TRIBUTADO" }
            if (COFINS > 0) { cofins = IMPOSTO_ATIVO;cofins_descricao = "COFINS - RETIDO" }
            if (CSLL > 0) { csll = IMPOSTO_TRIBUTADO;csll_descricao = "CSLL - TRIBUTADO" }
        }
    }
    if (versao_pis_cofins === 2) {
        // Tributos 0 - PIS/COFINS/CSLL Tributados
        if (pis_cofins_status.value === "0") {
            if (PIS > 0) { pis = IMPOSTO_TRIBUTADO;pis_descricao = "PIS - TRIBUTADO" }
            if (COFINS > 0) { cofins = IMPOSTO_TRIBUTADO;cofins_descricao = "COFINS - TRIBUTADO" }
            if (CSLL > 0) { csll = IMPOSTO_TRIBUTADO;csll_descricao = "CSLL - TRIBUTADO" }
        }
        // Tributos 1 - PIS/COFINS Retido
        if (pis_cofins_status.value === "1") {
            if (PIS > 0) { pis = IMPOSTO_ATIVO;pis_descricao = "PIS - RETIDO" }
            if (COFINS > 0) { cofins = IMPOSTO_ATIVO;cofins_descricao = "COFINS - RETIDO" }
        }
        // Tributos 2 - PIS/COFINS Tributado
        if (pis_cofins_status.value === "2") {
            if (PIS > 0) { pis = IMPOSTO_TRIBUTADO;pis_descricao = "PIS - TRIBUTADO" }
            if (COFINS > 0) { cofins = IMPOSTO_TRIBUTADO;cofins_descricao = "COFINS - TRIBUTADO" }
        }
        // Tributos 3 - PIS/COFINS/CSLL Retidos
        if (pis_cofins_status.value === "3") {
            if (CSLL > 0) { csll = IMPOSTO_ATIVO;csll_descricao = "CSLL - RETIDO" }
            if (PIS > 0) { pis = IMPOSTO_ATIVO;pis_descricao = "PIS - RETIDO" }
            if (COFINS > 0) { cofins = IMPOSTO_ATIVO;cofins_descricao = "COFINS - RETIDO" }
        }
        // Tributos 4 - PIS/COFINS Retidos, CSLL Tributado
        if (pis_cofins_status.value === "4") {
            if (PIS > 0) { pis = IMPOSTO_ATIVO;pis_descricao = "PIS - RETIDO" }
            if (COFINS > 0) { cofins = IMPOSTO_ATIVO;cofins_descricao = "COFINS - RETIDO" }
            if (CSLL > 0) { csll = IMPOSTO_TRIBUTADO;csll_descricao = "CSLL - TRIBUTADO" }
        }
        // Tributos 5 - PIS Retido, COFINS/CSLL Tributado
        if (pis_cofins_status.value === "5") {
            if (PIS > 0) { pis = IMPOSTO_ATIVO;pis_descricao = "PIS - RETIDO" }
            if (COFINS > 0) { cofins = IMPOSTO_TRIBUTADO;cofins_descricao = "COFINS - TRIBUTADO" }
            if (CSLL > 0) { csll = IMPOSTO_TRIBUTADO;csll_descricao = "CSLL - TRIBUTADO" }
        }
        // Tributos 6 - COFINS Retido, PIS/CSLL Tributado
        if (pis_cofins_status.value === "6") {
            if (COFINS > 0) { cofins = IMPOSTO_ATIVO;cofins_descricao = "COFINS - RETIDO" }
            if (CSLL > 0) { csll = IMPOSTO_TRIBUTADO;csll_descricao = "CSLL - TRIBUTADO" }
            if (PIS > 0) { pis = IMPOSTO_TRIBUTADO;pis_descricao = "PIS - TRIBUTADO" }
        }
        // Tributos 7 - PIS Tributado, COFINS/CSLL Retidos
        if (pis_cofins_status.value === "7") {
            if (CSLL > 0) { csll = IMPOSTO_ATIVO;csll_descricao = "CSLL - RETIDO" }
            if (COFINS > 0) { cofins = IMPOSTO_ATIVO;cofins_descricao = "COFINS - RETIDO" }
            if (PIS > 0) { pis = IMPOSTO_TRIBUTADO;pis_descricao = "PIS - TRIBUTADO" }
        }
        // Tributos 8 - PIS/COFINS Tributados, CSLL Retido
        if (pis_cofins_status.value === "8") {
            if (CSLL > 0) { csll = IMPOSTO_ATIVO;csll_descricao = "CSLL - RETIDO" }
            if (PIS > 0) { pis = IMPOSTO_TRIBUTADO;pis_descricao = "PIS - TRIBUTADO" }
            if (COFINS > 0) { cofins = IMPOSTO_TRIBUTADO;cofins_descricao = "COFINS - TRIBUTADO" }
        }
        // Tributos 9 - COFINS Tributado, PIS/CSLL Retidos
        if (pis_cofins_status.value === "9") {
            if (CSLL > 0) { csll = IMPOSTO_ATIVO;csll_descricao = "CSLL - RETIDO" }
            if (PIS > 0) { pis = IMPOSTO_ATIVO;pis_descricao = "PIS - RETIDO" }
            if (COFINS > 0) { cofins = IMPOSTO_TRIBUTADO;cofins_descricao = "COFINS - TRIBUTADO" }
        }
    }

    document.getElementById("ISS_descricao")!.style.backgroundColor = iss
    defineTextInElementId("ISS_descricao", iss_descricao)
    document.getElementById("IRRF_descricao")!.style.backgroundColor = irrf
    document.getElementById("IRRF_descricao")!.innerText = irrf_descricao
    document.getElementById("INSS_descricao")!.style.backgroundColor = inss
    document.getElementById("INSS_descricao")!.innerText = inss_descricao
    document.getElementById("CSLL_descricao")!.style.backgroundColor = csll
    document.getElementById("CSLL_descricao")!.innerText = csll_descricao
    document.getElementById("PIS_descricao")!.style.backgroundColor = pis
    document.getElementById("PIS_descricao")!.innerText = pis_descricao
    document.getElementById("COFINS_descricao")!.style.backgroundColor = cofins
    document.getElementById("COFINS_descricao")!.innerText = cofins_descricao
}

async function sleep(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
